/**
 * Acumulacion de paginas para los listados con scroll infinito de la bandeja.
 *
 * Vive aparte del hook (y no como logica inline) porque es la parte con reglas
 * — apendizar sin perder lo cargado y avanzar el offset EXACTAMENTE por lo
 * recibido — y es donde estan los dos fallos faciles: repetir la pagina 1 para
 * siempre (offset que no avanza) o perder lo ya cargado (reemplazar en vez de
 * apendizar). Al ser pura se prueba sin montar el hook entero.
 */
export interface PaginaAcumulada<T> {
  items: T[];
  offset: number;
  hasMore: boolean;
}

/**
 * Funde la pagina recibida con lo ya cargado.
 *
 * El offset avanza por la longitud REAL de la pagina, no por el tamano pedido:
 * la ultima pagina suele venir corta, y sumar el tamano nominal dejaria un hueco
 * que se saltaria entradas en la peticion siguiente.
 */
export function siguientePagina<T>(
  cargados: T[],
  offset: number,
  pagina: T[],
  hasMore: boolean,
): PaginaAcumulada<T> {
  return {
    items: [...cargados, ...pagina],
    offset: offset + pagina.length,
    hasMore,
  };
}
